import {
  getContrast,
  hashInt,
  hslToRgb,
  hslToRgba,
} from '@livekatsomo/shared/utils';
import { Decoration } from 'prosemirror-view';

export const createTelepointers = (
  from: number,
  to: number,
  clientID: string,
  isSelection: boolean,
  initial: string,
) => {
  const decorations: Decoration[] = [];
  const avatarColor = getAvatarColor(initial);

  if (isSelection) {
    const className = `telepointer telepointer-selection`;
    decorations.push(
      Decoration.inline(
        from,
        to,
        {
          class: className,
          'data-initial': initial,
          style: 'background-color: ' + avatarColor.selectionColor,
        },
        {
          clientID,
        },
      ),
    );
  }

  const ZeroWidthSpace = '\u200b';
  const cursor = document.createElement('span');
  cursor.textContent = ZeroWidthSpace;
  cursor.className = `telepointer telepointer-selection-badge`;
  cursor.style.cssText = `${style({
    color: avatarColor.color,
    bgColor: avatarColor.bgColor,
  })};`;
  cursor.setAttribute('data-initial', initial);
  return decorations.concat(
    Decoration.widget(to, cursor, {
      clientID,
      key: `telepointer-${clientID}`,
    }),
  );
};

function style({ color, bgColor }: { color: string; bgColor: string }) {
  return `--badge-bg-color: ${bgColor}; --badge-color: ${color}; color: ${color}; border-left: 1px solid ${bgColor}; border-right: 1px solid ${bgColor}; margin-right: -2px; `;
}

const getAvatarColor = (name: string) => {
  const hue = hashInt(name, 360);
  const bgColor = hslToRgb(hue / 360, 1, 0.8);
  const selectionColor = hslToRgba(hue / 360, 1, 0.8, 0.44);
  const contrast = getContrast(bgColor);

  return {
    bgColor,
    color: contrast === 'light' ? 'white' : 'black',
    selectionColor,
  };
};
